import { render, staticRenderFns } from "./LiveCenter.vue?vue&type=template&id=198bf910&scoped=true&"
import script from "./LiveCenter.vue?vue&type=script&lang=js&"
export * from "./LiveCenter.vue?vue&type=script&lang=js&"
import style0 from "./LiveCenter.vue?vue&type=style&index=0&id=198bf910&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198bf910",
  null
  
)

component.options.__file = "LiveCenter.vue"
export default component.exports